import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchClientInvoices,
  setLoading,
  showFilterModal,
  updateFilters,
  updatePagination,
} from "@/reducers/clientinvoice";

import TableSearch from "../dataTables/TableSearch";
import FilterButton from "../ListingFilters/FilterButton";

/**
 * Generates the search filter component with search input and filter button.
 */
const SearchFilter = () => {
  const { filters, pagination } = useSelector((state) => state.clientInvoices);
  const filterApplied = Object.values(filters).some(
    (item) =>
      item !== "" &&
      item !== null &&
      (Array.isArray(item) ? item.length > 0 : true),
  );
  const dispatch = useDispatch();
  /**
   * A function that handles the search event.
   *
   * @param {Event} e - the event object
   * @return {void}
   */
  const handleSearch = (e) => {
    dispatch(updateFilters({ search: e.target.value }));
  };
  const firstUpdate = useRef(true);
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    const delayDebounceFn = setTimeout(() => {
      dispatch(setLoading(true));
      dispatch(
        updatePagination({
          ...pagination,
          currentPage: 1,
          isLastPage: false,
        }),
      );
      dispatch(fetchClientInvoices(filters));
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [filters.search]);
  return (
    <div className="SearchFilter_Wrapper">
      <div className="flex gap-[20px]">
        <TableSearch val={filters.search} handleChange={handleSearch} />
        <FilterButton
          filterApplied={filterApplied}
          handleClick={() => {
            dispatch(showFilterModal(true));
          }}
        />
      </div>
    </div>
  );
};

export default SearchFilter;
